// src/components/PageSeo.jsx
//
// Genbrugelig Helmet-wrapper til per-side SEO. Uden denne arver stort set
// alle sider (bortset fra de få, der selv har en <Helmet>, se BrandPage.jsx)
// den samme statiske titel/beskrivelse fra index.html - dvs. forsidens
// tekst vises i Google-søgninger og i delings-forhåndsvisninger (Facebook/
// LinkedIn/Slack) uanset hvilken side der faktisk deles. Bruger samme
// mønster som det allerede etablerede i BrandPage.jsx.
//
// path skal starte med "/" (fx "/faq"). schema er valgfri JSON-LD (et
// almindeligt objekt - JSON.stringify'es her). alternates er valgfri
// [[hreflang, sti], ...] til sider, der findes på flere sprog.

import { Helmet } from "react-helmet-async";

const SITE_URL = "https://offlist.dk";
const DEFAULT_IMAGE = `${SITE_URL}/logos/OFFLIST2.png`;

export default function PageSeo({ title, description, path, image = DEFAULT_IMAGE, schema, noindex = false, alternates = [], lang }) {
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {lang && <html lang={lang} />}
      <link rel="canonical" href={canonicalUrl} />
      {alternates.map(([hl, sti]) => <link key={hl} rel="alternate" hrefLang={hl} href={`${SITE_URL}${sti}`} />)}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
